import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sidebar/special",
  "use": "sidebar/special-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sidebar/special\"><path d=\"M18.53 19.24H5.4a.74.74 0 01-.71-.51L1.5 9a.73.73 0 01.22-.8.74.74 0 01.83-.1L8.37 11l3-5.82a.78.78 0 011.34 0l3 5.83 5.83-2.9a.73.73 0 01.82.1.749.749 0 01.14.79l-3.26 9.72a.74.74 0 01-.71.52zM6 17.74h12l2.51-7.49-4.87 2.42a.74.74 0 01-1-.33L12 7.16l-2.63 5.18a.74.74 0 01-1 .33l-4.89-2.45L6 17.74z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol